import { api } from "./api";

export const listarFichas = (params = {}) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  ).toString();
  return api.get(`/ficha/listar${qs ? `?${qs}` : ""}`);
};
export const obterFicha = (id) => api.get(`/ficha/${id}`);
export const salvarFicha = (dto) => api.post("/ficha/salvar", dto);
export const excluirFicha = (id) => api.post(`/ficha/excluir/${id}`);
export const analisarFicha = (id, dto) => api.post(`/ficha/analisar/${id}`, dto);
export const liberarEdicao = (id) => api.post(`/ficha/liberar-edicao/${id}`);
export const getRelatorio = (id) => api.get(`/ficha/relatorio/${id}`);
export const notificarIndeferimento = (id) => api.post(`/ficha/notificar-indeferimento/${id}`);
